import { Backdrop } from "@mui/material";
import { useAppSelector } from "../../hooks/useAppSelector";
import { RootState } from "../../redux/store";
import { styles } from "./styles";
import DotWaveLoader from "./loader";

const Loader = () => {
  const { loading } = useAppSelector((state: RootState) => state.global);

  return (
    <Backdrop sx={styles.loaderContainer} open={loading}>
      {/* <Box
          component="img"
          sx={styles.loaderImage}
          src={IMAGES.Loader}
          alt="Loader"
        /> */}
      <DotWaveLoader />
    </Backdrop>
  );
};

export default Loader;
